import { LoaderCircle } from 'lucide-react';
import './LoadingIconApp.scss';

const LoadingIconApp = ({ size, style, className = '' }) => {
  return (
    <LoaderCircle
      size={size}
      style={style}
      strokeWidth={1.25}
      className={`loading_icon_app ${className}`}
    />
  );
};

export default LoadingIconApp;
